export default __webpack_public_path__ + "static/media/FKGroteskNeue-Medium.73b8924f.woff";